import { ProfileServices } from './services'
import { ProfileAPI } from './api'
import { ApisauceInstance } from 'apisauce'
import * as profileStore from './stores'

export class ProfilesPackage {
  public API: ProfileAPI
  public Services: ProfileServices
  protected api: ApisauceInstance
  public Store: typeof profileStore

  constructor(api: ApisauceInstance) {
    this.api = api
    this.API = new ProfileAPI(this.api)
    this.Services = new ProfileServices(this.API)
    this.Store = profileStore
  }
}

export * from './types'
export * from './utils'
